import axios from "axios";

const spriteUrl =
  "https://sprites-as-a-service-tblytwilzq-ue.a.run.app/api/v1/sprite";

export const getSprite = (query: string, iters: number) =>
  axios
    .get(spriteUrl, {
      params: {
        q: query,
        size: 200,
        n_iters: iters,
      },
    })
    .then((response) => {
      return response.data;
    });
